import React from "react";
import { Route, Navigate,Router ,Routes,useLocation} from "react-router-dom";
import AsyncStorageFunc from '../utilities/asyncStorage'
import { useLogin } from "../context/loginProvider";
import { history } from "../utilities/RouterHelper";

export const PrivateRoute = ({ children }) => {
    const [hasPermission, setHasPermission] = React.useState(); // <-- initially undefined
    React.useEffect(() => {
      
          AsyncStorageFunc.getData("TOKEN").then(token=>{
            console.log("TOkenIn Private rooute", token)
            if(!token || token === ""){
                history.navigate("/Login");
            }else{
                setHasPermission(true);
            }
           
          })
      }, []);
      if (hasPermission === undefined) {
        // return null; // or loading indicator, spinner, etc
      }

      return children
   
  };

export default PrivateRoute;
 